import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Icon from "../../Assets/Icons/ART_Icon_Download";
import { Link } from "react-router-dom";
import "../../Assets/Css/App.css";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
    
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 500,
  },
}));


const useStylesTab = makeStyles(theme => ({
  root: {
    'font-size': 'unset',
    'font-weight': 'bold',

    '@media (max-width: 768px)': {
    "& .MuiTabs-flexContainer ": {
      'flex-wrap': 'wrap',
      'flex-direction': 'column',
    },}
  },
}));

export default function FullWidthTabs() {
  const classes = useStyles();
  const classesTab = useStylesTab();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = index => {
    setValue(index);
    
  };

  const state = {
    

    afiliaciones:[
      {
        Desc:"1",
        File: "1.pdf"
      }
    ],

    general:[
      {
        Desc:"1",
        File: "1.pdf"
      }
    ],

    prevencion: [
      {
        Desc:"1",
        File: "1.pdf"
      }
    ],

    prestaciones:[
      {
        Desc:"1",
        File: "1.pdf"
      }
    ],

  prestadoresmedicos:[   
    {
      Desc:"1",
      File: "1.pdf"
    }
  ],

  prestadores:[
    {
    Desc:"1",
    File: "1.xlsx"
    }
  ],
  };

  

  return (
    <Fragment>
    <div className={classes.root} className="container">

      <AppBar  position="static" >
      
        <Tabs 
          className={classesTab.root}
          value={value}
          onChange={handleChange}
          TabIndicatorProps={{style: {background:'#83BC00', height:'5px'}}}
          variant="fullWidth"
          aria-label="full width tabs example"
          style={{backgroundColor: '#83BC00', 'display': 'flex', 'flex-flow': 'column'}}
          //    font-size: x-large;
        >
       (showBulkActions ? 'show' : 'hidden')
          <Tab className={classesTab.root} label="POLIZA"      {...a11yProps(0)}/>
          <Tab className={classesTab.root} label="CERTIFICADO DE COBERTURA" {...a11yProps(1)}/>
          <Tab className={classesTab.root} label="3..."   {...a11yProps(2)}/>
          <Tab className={classesTab.root} label="4..." {...a11yProps(3)}/>
          <Tab className={classesTab.root} label="5..."  {...a11yProps(4)}/>
          <Tab className={classesTab.root} label="6..."  {...a11yProps(5)}/>
        
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
      <TabPanel value={value} index={0} dir={theme.direction}>
              <ul className="list-group">
                {state.afiliaciones.map(obj => (
                    <li 
                    key={obj.Desc}
                    className="list-item-descargas"
                    >
                      {obj.Desc}
                      <a href="#">
                      <Link to={"Download/AFILIACIONES/"+obj.File} target="_blank" download>
                        <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                      </Link>
                      </a>
                    </li>
                ))}
              </ul>
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
              <ul className="list-group">
                {state.general.map(obj => (
                    <li 
                    key={obj.Desc}
                    className="list-item-descargas"
                    >
                      {obj.Desc}
                      <a href="#">
                      <Link to={"Download/GENERAL/"+obj.File} target="_blank" download>
                        <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                      </Link>
                      </a>
                    </li>
                ))}
              </ul>
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
                <ul className="list-group">
                {state.prevencion.map(obj => (
                    <li 
                    key={obj.Desc}
                    className="list-item-descargas"
                    >
                    {obj.Desc}
                      <a href="#">
                      <Link to={"Download/PREVENCION/"+obj.File} target="_blank" download>
                        <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                      </Link>
                      </a>
                    </li>
                ))}
                </ul>
            
        </TabPanel>
        <TabPanel value={value} index={3} dir={theme.direction}>
                <ul className="list-group"> 
                {state.prestaciones.map(obj => (
                    <li 
                    key={obj.Desc}
                    className="list-item-descargas"
                    >
                      {obj.Desc}
                      <a href="#">
                      <Link to={"Download/PRESTACIONES/"+obj.File} target="_blank" download>
                        <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                      </Link>
                      </a>
                    </li>
                ))}
                </ul>
        </TabPanel>

        <TabPanel value={value} index={4} dir={theme.direction}>
                <ul className="list-group"> 
                {state.prestadoresmedicos.map(obj => (
                    <li 
                    key={obj.Desc}
                    className="list-item-descargas"
                    >
                      {obj.Desc}
                      <a href="#">
                      <Link to={"Download/PRESTADORES MEDICOS/"+obj.File} target="_blank" download>
                        <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                      </Link>
                      </a>
                    </li>
                ))}
                </ul>
        </TabPanel>

        <TabPanel value={value} index={5} dir={theme.direction}>
                <ul className="list-group"> 
                {state.prestadores.map(obj => (
                    <li 
                    key={obj.Desc}
                    className="list-item-descargas"
                    >
                      {obj.Desc}
                      <a href="#">
                      <Link to={"Download/PRESTADORES/"+obj.File} target="_blank" download>
                        <Icon style={{float: "right"}} fill="#F8A700" width={25} />
                      </Link>
                      </a>
                    </li>
                ))}
                </ul>
        </TabPanel>            
      </SwipeableViews>
    </div>
    </Fragment>
  );
}